import { createStore, applyMiddleware } from 'redux';

import thunk from 'redux-thunk';
import createSaga from 'redux-saga';

import reducers from './reducers';
import sagas from './sagas';

const saga = createSaga();
const middlewares = [thunk, saga];
const initialState = {};

const store = createStore(
  reducers,
  initialState,
  applyMiddleware(...middlewares),
);

saga.run(sagas);

export default store;
